export const TARGET_ORIGIN = "https://d1ux9mupljc68q.cloudfront.net";
